import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TokenService } from '../token/token.service';
import { environment as env } from 'src/environments/environment';
import { GetSystemSettingCountryShowList, SystemSettingCountry } from 'src/app/models/shared/auth/auth.interface';
import { HttpService } from '../http/http.service';
import { BaseResponse } from 'src/app/models/base.interface';
import { MerchantService } from '../merchant/merchant.service';

@Injectable({
    providedIn: 'root'
})
export class CurrencyService {
    private currencySubject = new BehaviorSubject<any>(null);
    selectedCurrency$ = this.currencySubject.asObservable();

    constructor(
        private token: TokenService,
        private httpService: HttpService,
        private merchantService: MerchantService,
    ) {
        this.initCurrencyFromStorage();
    }

    // Todo by Steven: maybe can remove, no need this function
    private initCurrencyFromStorage(): void {
        const stored = this.token.getLocalToken(env.TokenKeys.Currency) ?? '';
        if (stored) {
            try {
                const currency = JSON.parse(stored);
                this.currencySubject.next(currency);
            } catch {
                this.currencySubject.next(env.DefaultLanguageCode);
            }
        }
    }

    getCurrencyListFromStorage() {
        const stored = this.token.getLocalToken(env.TokenKeys.CurrencyList) ?? '';

        if (typeof stored === 'string') {
            try {
                return JSON.parse(stored);
            } catch (error) {
                return [];
            }
        }

        return Array.isArray(stored) ? stored : [];
    }

    setCurrency(currency: any) {
        this.currencySubject.next(currency);
        this.token.setLocalToken(env.TokenKeys.Currency, JSON.stringify(currency));
    }

    getCurrency() {
        return this.currencySubject.value;
    }

    getCurrencyList(): Promise<SystemSettingCountry[] | []> {
        return new Promise((resolve) => {
            const payload = {
                merchantId: this.merchantService.getMerchantId(),
                merchantCode: this.merchantService.getMerchantCode(),
            };

            this.httpService.post('public', 'SystemSetting', 'GetSystemSettingCountryShowList', payload, true)
                .subscribe((resp: BaseResponse<GetSystemSettingCountryShowList>) => {
                    if (resp && resp.code == 1) {
                        resolve(resp.data.systemSettingCountryShowList);
                    } else {
                        resolve([]);
                    }
                }, () => resolve([]));
        });
    }
}
